import { IEntitySchemaDefinition } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

const Fieldset = ui.S9Fieldset.default;
const S9PageSection = ui.S9PageSection.default;

type Props = {
  schema: IEntitySchemaDefinition | undefined;
};
const ProfileDetail = ({ schema }: Props) => {
  const fields = [
    {
      field: 'org_number',
      label: 'Organisation number',
      colSize: 12,
    },
    {
      field: 'account_id',
      label: 'Account number',
      colSize: 12,
    },
    {
      field: 'main_industry_name',
      label: 'Main industry name',
      colSize: 12,
    },
    {
      field: 'main_industry_code',
      label: 'Main industry code',
      colSize: 12,
    },
    {
      field: 'secondary_industry_name',
      label: 'Secondary industry name',
      colSize: 12,
    },
    {
      field: 'secondary_industry_code',
      label: 'Secondary industry code',
      colSize: 12,
    },
    {
      field: 'partner_id',
      label: 'Partner',
      colSize: 8,
    },
    {
      field: 'payment_waiver_end_dt',
      colSize: 8,
    },
    {
      field: 'is_active',
      colSize: 8,
    },
  ];

  return (
    <S9PageSection title="Profile details" size="sm">
      {schema && (
        <Fieldset
          context={{ id: undefined }}
          schema={schema}
          formFields={fields}
        />
      )}
    </S9PageSection>
  );
};

export default ProfileDetail;
